import { ResultType } from "../../../constants/resultType"

const listPageMap = new Map<ResultType | undefined, string>([
  [ResultType.ALL, "全部"],
  [ResultType.ARTICLE, "文章"],
  [ResultType.ISSUE, "專題"],
  [ResultType.VIDEO, "影片"],
  [ResultType.COUPON, "優惠券"],
])

export const getListingPageByTabKey = (
  tabKey: ResultType | undefined,
): string | undefined => {
  return listPageMap.get(tabKey) || undefined
}
